import { ImagePreviewType, maxIconImagesCount } from "@nova/constants"
import {
    CreateUploadFlow,
    CreateUploadFlowProps,
} from "panels/content/side-panel/upload-flow/UploadFlow"
import {
    deleteUpload,
    selectCancelledUploadIdsForSet,
    selectIconMockJob,
    selectSelectedUpload,
    selectSet,
    selectUploadIdsForSet,
    selectUploadsForSet,
    selectUploadsForSetSummary,
    setSelectedUpload,
    stageFiles,
    uploadIconImages,
} from "./IconSlice"
import { deleteIconImage } from "features/pubsub/entityActions/images/icon"
import {
    FileUploadCategory,
    supportedFileUploadExtensions,
} from "features/job-management/uploader/constants"
import { deleteIcon, updateIcon } from "features/pubsub/entityActions/cubes/icon"
import { selectIconById } from "features/entity-caching/icons/selectors"
import { getIconImageS3Key } from "panels/content/side-panel/upload-flow/constants"
import {
    selectIconFinishedUploadSize,
    selectIconUploadSize,
    selectIsIconUploading,
    selectSummaryFromIconUploads,
} from "features/entity-caching/images/icons/selectors"
import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { useIconProcessing } from "./useIconProcessing"
import { activateSidePanelModal } from "panels/content/side-panel/thunks"

export const IconUploadFlowProvider = CreateUploadFlow({
    selectSet,
    selectUploadIdsForSet,
    selectCancelledUploadIdsForSet,
    selectUploadsForSet,
    selectUploadsForSetSummary: selectUploadsForSetSummary,
    deleteUpload,
    deleteUploadedUpload: deleteIconImage,
    uploadFlight: uploadIconImages,
    stageFiles,
    selectJob: selectIconMockJob,
    setSelectedPlugin: activateSidePanelModal,
    useProcessing: useIconProcessing,
    minUploads: 1,
    maxUploads: maxIconImagesCount,
    selectSelectedUpload: selectSelectedUpload as unknown,
    setSelectedUpload,
    supportedFileUploadExtensions: supportedFileUploadExtensions[FileUploadCategory.Logo],
    deleteFlight: deleteIcon,
    updateFlight: updateIcon,
    selectFlightById: selectIconById,
    getS3Key: getIconImageS3Key,
    selectIsUploading: selectIsIconUploading,
    selectUploadSize: selectIconUploadSize,
    selectFinishedUploadSize: selectIconFinishedUploadSize,
    selectUploadStateSummary: selectSummaryFromIconUploads,
    imagePreviewType: ImagePreviewType.Icon,
    pluginId: NovaPluginIds.Icon,
} as CreateUploadFlowProps)
